export default __webpack_public_path__ + "static/media/e-sip-dpo-logo-b_10102026.769e8109.png";